import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-500/15 text-accent-400 text-xs font-medium mb-3 whitespace-nowrap">
            大家都在搜
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-xl mx-auto">
            点击话题标签，查看相关黑料合集
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {topicsData.map((topic) => (
              <a
                key={topic.id}
                href="#"
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer border ${
                  topic.hot
                    ? 'bg-primary-500/10 text-primary-400 border-primary-500/30 hover:bg-primary-500/20'
                    : 'bg-background-100 text-foreground-400 border-background-300/50 hover:border-foreground-500/30 hover:text-foreground-200'
                }`}
              >
                {topic.hot && <i className="ri-fire-line text-xs"></i>}
                <span>{topic.name}</span>
                <span className={`text-xs ${topic.hot ? 'text-primary-500/70' : 'text-foreground-600'}`}>
                  {topic.heat}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}